export const initEnvironmentReact = {
  CDN_URL: '${VITE_CDN_URL}',
  FINGERPRINT_TOKEN: '${FINGERPRINT_TOKEN}',
  SENTRY_DSN: '${VITE_SENTRY_DSN}',
  SENTRY_RELEASE: '${SERVICE_VERSION}',
  SERVICE_VERSION: '${SERVICE_VERSION}',
}
